/**
 * Format an ISO date string (YYYY-MM-DD) into a human readable date such as
 * "10 Jan 2026". Keep this in one place so every date on the site matches.
 */
export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}